// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"192":"35b7c5c8","626":"56cc7671","988":"4b63f9ec"}[chunkId] + ".css";
};